<template>
    <div id="class_detail" >
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class="header">
                <i class="icon_fanhui" @click="goBack"></i>
                <p>{{ unit_name }}</p>
                <span class="more flex ac" @click="handleShowMenu"><i></i><i></i><i></i></span>
                <div class="menu" v-if="show_menu">
                    
                    <div class="item flex ac" @click="search_stu"><img src="./img/icon_class_add.png" />
                        <p>添加学生</p>
                    </div>
                    <div class="item flex ac" @click="exit_calss"><img src="./img/icon_class_exit.png" />
                        <p>退出班级</p>
                    </div>
                </div>
                <div class="menu_mask" @click="hideMenu" v-if="show_menu"></div>
            </div>
            <div class="tab flex ac jb">
                <div class="item" :class="active==1?'active':''" @click="handleChoose(1)">全部({{ class_info .all_num }})
                </div>
                <div class="item" :class="active==2?'active':''" @click="handleChoose(2)">已开通({{ class_info .open_num }})</div>
                <div class="item" :class="active==3?'active':''" @click="handleChoose(3)">体验({{ class_info .free_num }})
                </div>
                <div class="item" :class="active==4?'active':''" @click="handleChoose(4)">未开通({{ class_info .un_open_num }})</div>
            </div>
            <div class="stu_list" v-if="indexList.length">
                <div class="stu_item" v-for="(item,index) in indexList" :key="index">
                    <div class="str">{{item.title }}</div>
                    <div class="item flex jb ac" v-for="(item2, index2) in item.datas" :key="index2" @click="choose_stu(item2)">
                        <div class="info flex ac">
                            <img src="https://cdn.m.tbkt.cn/stu_default.png" class="avatar" />
                            <div class="text">
                                <div class="name flex ac">{{item2.name.stu_name }} <img :src="item2.name.state==2 ?require('./img/yi.png'): item2.name.state ==1 ? require('./img/ti.png'): require('./img/wei.png')" class="icon"  /></div>
                                <div class="phone">({{ item2.name.phone.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2") }})</div>
                                <div class="last_use">最近使用 {{ item2.name.make_task_time }}</div>
                            </div>
                        </div>
                        <div class="edit flex ac">
                            <template v-if="!is_batch">
                                <div class="btn" @click="send_account(item2)">下发账号</div>
                                <img src="./img/icon_delete.png" class="icon_delete" @click="remove_user(item2)"/>
                            </template>
                            <template v-else>
                                <img src="./img/icon-select.png"  v-if="item2.select"/>
                                <img src="./img/icon-noselect.png" v-else />
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <noResouse v-else text="暂无学生"></noResouse>
            <div class="fix-btm flex jb ac" v-if="indexList.length">
                <template v-if="!is_batch">
                    <div class="btn remove" @click="batch_remove">批量移除班级</div>
                    <div class="btn invate" @click="batch_invate" v-if="active == 1 || active == 4">批量邀请开通</div>
                </template>
                <div class="btn remove" @click="handle_batch_remove" v-if="is_batch&& is_remove_unit">移除班级</div>
                <div class="btn invate" @click="handle_batch_invate" v-if="is_batch&& !is_remove_unit">邀请开通</div>
                <div class="all_choose flex jb ac" v-if="is_batch">
                    <p class="all_choose_cancel" @click="all_choose_cancel">取消</p>
                    <p class="all_choose_edit flex  ac" @click="choose_all">
                        <img src="./img/icon-select.png"  v-if="is_all"/>
                        <img src="./img/icon-noselect.png" v-else />
                        <span>全选</span>
                    </p>
                </div>
            </div>
            <div class="open" v-if="showOpen">
                <div class="main">
                    <p class="title">短信内容：</p>
                    <div class="text">
                        {{msg_content}}
                    </div>
                    <div class="btn flex jb ac">
                        <span class="cancel" @click="cancel">取消</span>
                        <span class="send" @click="send">下发账号</span>
                    </div>
                </div>
            </div>
            <div class="open share_open" v-if="showshareOpen">
                <div class="main">
                    <p class="title">短信内容：</p>
                    <p class="desc invate_tips">在家长收到10086下发的邀请开通短信前，先收到本条引导短信，老师可根据班级实际情况通过该短信告知家长。</p>
                    <p class="desc c-f60">开通学科仅限河南移动用户，其他运营商无法收到邀请短信且无法开通</p>
                    <div class="text">
                        {{msg_content}}
                    </div>
                    <div class="btn flex jb ac">
                        <span class="cancel" @click="cancel">关闭</span>
                        <span class="send" @click="send_invate_msg">发送</span>
                    </div>
                </div>
            </div>
            <div class="fix_btm_open_share" :class="is_show_share_open?'show':''">
                <div class="title">请选择邀请方式</div>
                <div class="invate_list flex ac">
                    <div class="item" @click="share_msg">
                        <img src="./img/icon_msg.png"  />
                        <p>短信</p>
                    </div>
                    <div class="item" @click="copy_share_link">
                        <img src="./img/icon_link.png"  />
                        <p>复制网址</p>
                    </div>
                </div>
                <div class="cancel_share" @click="cancel_share">
                    取消分享
                </div>
            </div>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
    import loadings from "COMPONENTS/base/loadingS.vue";
    import noResouse from 'COMPONENTS/noResouse.vue';
    import Pinyin from 'SRC/plugins/pinyin.js';
    export default {
        components: {
            loadings,
            noResouse,
        },
        data() {
            return {
                loading: true,
                show_menu: false,
                unit_class_id: this.$route.params.unit_class_id,
                sid: this.$route.params.sid,
                unit_name: this.$route.query.unit_name,
                tab: ['全部', '已开通', '体验', '未开通'],
                active: 1,
                class_info: {},
                all_stu:[],//所有学生
                indexList:[],//按拼音首字母排序后的数据,每次tab切换都会变
                showOpen:false,
                showshareOpen:false,//邀请开通的短信弹窗
                msg_content:'',//短信内容
                phone:'',//下发账号密码是存储一下，用于两个方法之间的中转
                is_batch:false,//是否处于批量选择状态
                is_all:false,//当前是否全选
                is_remove_unit:true,//判断当前是批量移除还是批量邀请
                is_show_share_open:false,//判断当前是批量移除还是批量邀请
            }
        },
        created() {
            this.detail()
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            //获取班级数据详情
            detail() {
                this.$http.post(API_URL_BASE_API + '/unit/region/class_manage/', {
                    unit_class_id: this.unit_class_id,
                    sid: this.sid
                }).then(res => {
                    this.loading = false
                    if (res.data.response == 'ok') {
                        this.class_info = res.data.data
                        this.all_stu = res.data.data.students
                        this.pinyinSort(res.data.data.students)
                    } else {
                        layer.tips(res.data.message)
                    }
                })
            },
            //右上角菜单
            handleShowMenu() {
                this.show_menu = !this.show_menu
            },
            //tab切换
            handleChoose(num) {
                this.is_all=this.is_batch=false
                this.active = num
                let _arr=[]
                if(num==1){
                    //所有
                    _arr=this.all_stu
                }else if (num == 2) {
                    //已开通
                    this.all_stu.forEach(e => {
                        if(e.state ==2){
                            _arr.push(e)
                        }
                    })
                } else if (num == 3) {
                    //体验
                    this.all_stu.forEach(e => {
                        if (e.state == 1) {
                            _arr.push(e)
                        }
                    })
                } else if (num == 4) {
                    //未开通
                    this.all_stu.forEach(e => {
                        if (e.state == 0) {
                            _arr.push(e)
                        }
                    })
                }
                this.pinyinSort(_arr)
            },
            pinyinSort (ind) {
                var pinyinArray = new Array();
                for (var bukn = 0; bukn < ind.length; bukn++) {
                    var o = new Object();
                    var ken = Pinyin.getSpell(ind[bukn].stu_name, function (charactor, spell) {
                        return spell[1];
                    });
                    o.name = ind[bukn];
                    o.pinyin = ken.split(',').join('');
                    
                    pinyinArray.push(o);
                }
                let map = {
                    title: '',
                    datas: [],
                };
                pinyinArray.forEach((item, index) => {
                    if (!map[item.pinyin[0].toUpperCase()]) {
                        map[item.pinyin[0].toUpperCase()] = {
                            title: item.pinyin[0].toUpperCase(),
                            datas: []
                        };
                    }
                    map[item.pinyin[0].toUpperCase()].datas.push({
                        name: item.name,
                        pinyin: item.pinyin,
                        select: false,
                    });
                });
                var turn = new Array();
                var letters = '*ABCDEFGHIJKLNMOPQRSTUVWXYZ'.split('');
                for (var i = 1; i < letters.length; i++) {
                    if (map[letters[i]]) {
                        var obj = new Object();
                        obj.title = letters[i];
                        obj.datas = map[letters[i]].datas;
                        turn.push(obj);
                    }
                }
                //对景区名称进行排序
                let arr = turn;
                var compare = function (obj1, obj2) {
                    var val1 = obj1.pinyin;
                    var val2 = obj2.pinyin;
                    if (val1 < val2) {
                        return -1;
                    } else if (val1 > val2) {
                        return 1;
                    } else {
                        return 0;
                    }
                };
                for (let i = 0; i < arr.length; i++) {
                    arr[i].datas.sort(compare);
                }
                this.indexList = arr;
            },
            //下发账号按钮
            send_account(item){
                this.phone=item.name.phone
                layer.open({ type: 2, shadeClose: false, });
                this.$http.post(API_URL_BASE_API + '/unit/region/stu/account', {
                    account_id: item.name.account_id,
                    place_id: 1
                }).then(res => {
                    layer.closeAll();
                    if (res.data.response == 'ok') {
                       this.showOpen = true
                        this.msg_content = res.data.data.content
                    }
                     else {
                        layer.tips(res.data.message)
                    }
                })
            },
            cancel(){
                this.showshareOpen=this.showOpen=false
            },
            //下发账号密码请求
            send(){
                if(!this.phone){
                   layer.tips('无法获取该学生手机号码')
                   return
                }
                this.$http.post(API_URL_BASE_API + '/unit/region/stu/account/send', {
                    content: this.msg_content,
                    phone: this.phone,
                    place_id: 1
                }).then(res => {
                    if(res.data.response=='ok'){
                         this.showOpen = false
                         layer.tips('发送成功')
                    }
                   
                })
            },
            //移除学生
            remove_user (item){
                let that=this
                layer.open({
                    diff: 'tea',
                    content: '您确定要将该学生移除班级？其他任课老师也看不到该学生。',
                    btn: ['是', '否'],
                    yes: function (index) {
                        that.remove_user_req(item.name.user_id)
                        layer.close(index);
                    }
                })
            },
            //移除学生的请求
            remove_user_req(user_ids){
                let that = this
                that.$http.post(API_URL_BASE_API + '/unit/region/del_many_stu/', {
                    sid: that.sid,
                    unit_class_id: that.unit_class_id,
                    students: user_ids
                }).then(res => {
                    if (res.data.response == 'ok') {
                        layer.tips('移除成功')
                        this.class_info = res.data.data
                        this.all_stu = res.data.data.students
                        this.pinyinSort(res.data.data.students)
                        that.handleChoose(that.active)
                    }
                })
            },
            //批量移除按钮
            batch_remove(){
                this.is_remove_unit=this.is_batch=true  
            },
            //批量邀请按钮
            batch_invate(){
                this.is_batch = true
                this.is_remove_unit = false
                let _arr=[]
                this.all_stu.forEach(e => {
                        if (e.state == 0) {
                            _arr.push(e)
                        }
                    })
                this.pinyinSort(_arr)
            },
            //选中学生事件
            choose_stu(item){
                if(!this.is_batch){
                    return
                }
                let all_stu_num=null
                let hav_choose_num=null
                item.select=!item.select
                this.indexList.forEach(e=>{
                    e.datas.forEach(e2=>{
                        all_stu_num++
                        if(e2.select){
                            hav_choose_num++
                        }
                    })
                })
                if(all_stu_num== hav_choose_num){
                    this.is_all=true
                }else{
                    this.is_all =false
                }
            },
            //退出全选状态
            all_choose_cancel(){
                this.is_all = this.is_remove_unit=this.is_batch=false
                this.indexList.forEach(e => {
                    e.datas.forEach(e2 => {
                        e2.select=false
                    })
                })
            },
            //全选
            choose_all(){
                if(!this.is_all){
                    this.indexList.forEach(item => {
                        item.datas.forEach(item2 => {
                            item2.select = true
                        })
                    })
                    this.is_all=true
                }else{
                    this.indexList.forEach(item => {
                        item.datas.forEach(item2 => {
                            item2.select = false
                        })
                    })
                    this.is_all = false
                }
            },
            //移除所选中的学生
            handle_batch_remove(){
                let ids=[];
                this.indexList.forEach(e => {
                    e.datas.forEach(e2 => {
                        if(e2.select){
                            ids.push(e2.name.user_id)
                        }
                    })
                })
                let idsstr=ids.join(',')
                let that=this
                layer.open({
                    diff: 'tea',
                    content: '确定要将选中的学生移除班级吗？',
                    btn: ['确定', '取消'],
                    yes: function (index) {
                        that.remove_user_req(idsstr)
                        layer.close(index);

                    }
                })
            },
            //批量邀请请求按钮，弹出分享列表
            handle_batch_invate(){
                let ids = [];
                this.indexList.forEach(e => {
                    e.datas.forEach(e2 => {
                        if (e2.select) {
                            ids.push(e2.name.user_id)
                        }
                    })
                })
                if(!ids.length){
                    layer.tips('请选择邀请的学生')
                    return
                }
                this.is_show_share_open=true
            },
            //取消分享
            cancel_share(){
                this.is_show_share_open =false
            },
            //分享邀请链接
            copy_share_link(){
                let that=this
                let platform=JSON.parse(localStorage.getItem('info')).platform_id
                let content =`邀请您加入同步课堂，可帮助孩子快速提高学习成绩。链接：`+ WAP_URL+ `/common/invite_open/?platform=${platform}&sid=${this.sid}&unit_class_id=${this.unit_class_id}&school=${this.class_info.students[0].school_name}&class=${this.unit_name}&subject_id=${this.sid}`
                layer.alert('将链接粘贴并发送到对应的班级群，家长点击链接即可。', 'tea', function (index) {
                    layer.close(index)
                    that.copyText(content)
                    that.is_show_share_open = false
                }, '分享链接复制成功')
            },
            copyText (text) {
                const input = document.createElement('input');
                input.setAttribute('readonly', 'readonly');
                input.setAttribute('value', text);
                document.body.appendChild(input);
                input.setSelectionRange(0, 9999);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
            },
            share_msg(){
                this.is_show_share_open=false
                let data={}
                if(this.sid==11){
                    data.sms_id=52,
                    data.place_id=127
                }else if(this.sid==12){
                    data.sms_id = 53,
                    data.place_id = 128
                }else if(this.sid == 13) {
                    data.sms_id = 54,
                    data.place_id = 129
                }else{
                    data.sms_id = 2,
                    data.place_id = 5
                }
                this.$http.post(API_URL_BASE_API + '/sms/get_sms/', data).then(res => {
                    if (res.data.response == 'ok') {
                       this.showshareOpen =true
                       this.msg_content=res.data.data.content
                    }
                })
            },
            //发送邀请短信请求
            send_invate_msg(){
                let ids = [];
                this.indexList.forEach(e => {
                    e.datas.forEach(e2 => {
                        if (e2.select) {
                            ids.push(e2.name.user_id)
                        }
                    })
                })
                let idsstr = ids.join(',')
                let data={
                    sid:this.sid,
                    unit_class_id:this.unit_class_id,
                    user_ids:idsstr
               }
                if (this.sid == 11) {
                    data.sms_id = 52,
                    data.place_id = 127
                } else if (this.sid == 12) {
                    data.sms_id = 53,
                        data.place_id = 128
                } else if (this.sid == 13) {
                    data.sms_id = 54,
                        data.place_id = 129
                } else {
                    data.sms_id = 2,
                        data.place_id = 5
                }
                
                this.$http.post(API_URL_BASE_API + '/sms/invite_stu_new/', data).then(res => {
                    if (res.data.response == 'ok') {
                        layer.tips('发送成功')
                    }else{
                        layer.tips(res.data.message)
                    }
                })
            },
            mask(){
                if(!this.show_menu){
                    return
                }else{
                    this.show_menu=false
                }
            },
            hideMenu(){
                this.show_menu=false
            },
            //添加学生
            search_stu(){
                this.$router.push('/classlist/search/'+this.unit_class_id)
            },
            //退出班级
            exit_calss(){
                let that=this
                this.show_menu = false
                layer.open({
                    diff: 'tea',
                    content: '确定退出本班吗？退出后您将不再任教本班级，将无法查看该班学生信息和作业信息。',
                    btn: ['确定', '取消'],
                    yes: function (index) {
                        that.$http.post(API_URL_BASE_API + '/unit/region/quit_class/',{
                            sid: that.sid,
                            unit_class_id: that.unit_class_id,
                        }).then(res => {
                        layer.close(index);
                        if (res.data.response == 'ok') {
                            layer.tips(res.data.message)
                            that.$router.go(-1)
                        } else {
                            layer.tips(res.data.message)
                        }
                    })
                    }
                })
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .flex {
        display: flex;
    }

    .jb {
        justify-content: space-between;
    }

    .ac {
        align-items: center;
    }

    #class_detail {
        padding-top: 189px/$ppr;
        padding-bottom: $h-header;
    }

    .header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 8;
        height: $h-header;
        line-height: $h-header;
        color: #fff;
        font-size: 34px / $ppr;
        text-align: center;
        background: #5e89ef;

        .icon_fanhui {
            display: block;
            width: 76px / $ppr;
            height: $h-header;
            background-image: url("./img/back.png");
            background-position: center;
            background-size: 18px / $ppr 34px / $ppr;
            background-repeat: no-repeat;
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
        }

        span {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            padding: 0 24px/$ppr;
            height: $h-header;
            line-height: $h-header;

            i {
                width: 8px/$ppr;
                height: 8px/$ppr;
                border-radius: 100%;
                background: #fff;
                margin: 0 3px/$ppr;
            }
        }
        .menu_mask{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 9;
            opacity: 0;
        }
        .menu {
            position: absolute;
            right: 12px/ $ppr;
            top: 76px/ $ppr;
            background: #4c4c4c;
            border-radius: 5px/ $ppr;
            padding: 0 30px/ $ppr;
            z-index: 10;
            &:before {
                content: '';
                position: absolute;
                top: -8px/ $ppr;
                right: 25px/ $ppr;
                width: 20px/ $ppr;
                height: 20px/ $ppr;
                background: #4c4c4c;
                border-radius: 4px/ $ppr;
                transform: rotate(45deg);
            }
            
            .item {
                padding: 20px/ $ppr 10px/ $ppr;
                border-bottom: 1px/ $ppr solid #999;
                font-size: 24px/ $ppr;
                color: #fff;
                line-height: 1;

                &:last-child {
                    border-bottom: 0;
                }

                img {
                    width: 25px/$ppr;
                    height: 25px/$ppr;
                    margin-right: 20px/ $ppr;
                }
            }
        }
    }

    .tab {
        background: #fff;
        padding: 0 20px/$ppr;
        position: fixed;
        left: 0;
        right: 0;
        top: 96px/$ppr;
        width: 100%;
        box-sizing: border-box;
        .item {
            text-align: center;
            font-size: 28px/$ppr;
            padding: 30px/$ppr 0;
            border-bottom: 2px/ $ppr solid #fff;

            &.active {
                color: #5e89ef;
                border-bottom: 2px/ $ppr solid #5e89ef;
            }
        }
    }

    .stu_list {
        background: #F5F9FF;

        .stu_item {
           
            .str {
                font-size: 28px/$ppr;
                 padding: 20px/ $ppr 24px/ $ppr;
            }

            .item {
                background: #fff;
                padding: 10px/ $ppr 24px/ $ppr;
                border-bottom:1px/$ppr solid #e8e8e8;
                &:last-child{
                    border-bottom: 0;
                }
                .info {
                    .avatar {
                        width: 70px/ $ppr;
                        height: 70px/ $ppr;
                        border-radius: 50%;
                        margin-right: 20px/ $ppr;
                    }

                    .text {
                        line-height: 1.8;
                        .name {
                            font-size: 26px/ $ppr;
                            .icon{
                                width: 32px/ $ppr;
                                height: 32px/ $ppr;
                                margin-left: 10px/ $ppr;
                            }
                        }

                        .phone {
                            color: #999;
                            font-size: 20px/ $ppr;
                        }

                        .last_use {
                            color: #999;
                            font-size: 20px/ $ppr;
                        }
                    }
                }
                .edit{
                    .btn{
                        font-size: 24px/$ppr;
                        color: #fff;
                        padding: 12px/$ppr 30px/$ppr;
                        background:#5e89ef;
                        border-radius: 35px/$ppr;
                        margin-right: 20px/$ppr;
                    }
                    .icon_delete{
                        width: 28px/$ppr;
                        height: 28px/$ppr;
                    }
                }
            }
        }
    }
    .fix-btm{
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding:12px/$ppr 24px/$ppr;
        background:#fff;
        .btn{
            flex: 1;
            color: #fff;
            font-size: 28px/$ppr;
            text-align: center;
            border-radius: 50%;
            line-height: 72px/$ppr;
            border-radius: 72px/$ppr;
        }
        .remove{
            background:#FF6600;
           
        }
        .invate{
            background:#2ACA94;
             margin-left: 20px/$ppr;
        }
        .all_choose{
            .all_choose_cancel{
                color: #5e89ef;
                margin:0 50px/$ppr;
            }
            .all_choose_edit{
                img{
                    margin-right: 10px/$ppr;
                }
            }
        }
        
    }
    .open{
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background:rgba(0,0,0,.7);
        
        .main{
            position: absolute;
            width: 86%;
            left: 7%;
            top: 50%;
            transform: translateY(-50%);
            background:#fff;
            border-radius: 20px/$ppr;
            .title{
                padding: 20px/$ppr 20px/$ppr 0;
                color: #999;
                font-size: 28px/$ppr;
            }
            .text{
                background:#F2F2F2;
                border-radius: 20px/$ppr;
                border:1px/$ppr solid #999;
                padding: 20px/$ppr;
                line-height: 1.3;
                font-size: 24px/$ppr;
                color: #333;
                margin: 20px/$ppr;
            }
            .btn{
                border-top: 1px/$ppr solid #eaeaea;
                span{
                    flex: 0 0 50%;
                    text-align: center;
                    padding: 20px/$ppr 0;
                    font-size: 24px/$ppr;
                }
                .send{
                    border-left: 1px/$ppr solid #eaeaea;
                    color: #5e89ef;
                }
            }
        }
    }
   .fix_btm_open_share{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        background:#f0f0f0;
        transform: translateY(100%);
        transition: all .3s linear;
        .title{
            text-align: center;
            font-size: 24px/$ppr;
            padding: 20px/$ppr 0;
        }
        .invate_list{
            padding: 20px/$ppr 0;
            justify-content: center;
            .item{
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 0 20px/$ppr;
                img{
                    width: 72px/$ppr;
                    height: 72px/$ppr;
                }
                p{
                    font-size: 20px/$ppr;
                    margin-top:10px/$ppr;
                }
            }
        }
        .cancel_share{
            background:#fff;
            font-size: 24px/$ppr;
            text-align: center;
            padding: 20px/$ppr 0;
        }
        &.show{
            transform: translateY(0);
        }
   }
   .invate_tips{
        font-size: 24px/$ppr;
        color: #999;
        padding:10px/$ppr 20px/$ppr;
    }
   .c-f60{
        color: #f60;
        font-size: 24px/$ppr;
        padding:10px/$ppr 20px/$ppr;
   }
</style>